/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyPeso = createReactComponent("outline", "currency-peso", "IconCurrencyPeso", [["path", { "d": "M8 19v-14h3.5a4.5 4.5 0 1 1 0 9h-3.5", "key": "svg-0" }], ["path", { "d": "M18 8h-12", "key": "svg-1" }], ["path", { "d": "M18 11h-12", "key": "svg-2" }]]);

export { IconCurrencyPeso as default };
//# sourceMappingURL=IconCurrencyPeso.mjs.map
